import React from 'react';
import PropTypes from 'prop-types';

import FilterChipContainerWrapper from './FilterChipContainerWrapper';
import FilterChipContainer from './FilterChipContainer';

const propTypes = {
  chipScrollOffset: PropTypes.number,
  filters: PropTypes.arrayOf(PropTypes.object).isRequired,
  filterChipStyles: PropTypes.object,
  filterStyles: PropTypes.object,
  handleChipClick: PropTypes.func.isRequired,
  getContainerComponent: PropTypes.func.isRequired,
  getWrapperComponent: PropTypes.func.isRequired,
  scrollDuration: PropTypes.number,
  showLeftScroll: PropTypes.bool,
  showRightScroll: PropTypes.bool,
};

const defaultProps = {
  chipScrollOffset: 0,
  filterChipStyles: {},
  filterStyles: {},
  scrollDuration: null,
  showLeftScroll: false,
  showRightScroll: false,
};

const FilterScrollContainer = props => {
  return (
    <FilterChipContainerWrapper
      filterChipStyles={props.filterChipStyles}
      filterStyles={props.filterStyles}
      getWrapperComponent={props.getWrapperComponent}
      showLeftScroll={props.showLeftScroll}
      showRightScroll={props.showRightScroll}
    >
      <FilterChipContainer
        chipAddedFadeInDuration={props.chipAddedFadeInDuration}
        closeChipLabel={props.closeChipLabel}
        chipScrollOffset={props.chipScrollOffset}
        filters={props.filters}
        filterChipStyles={props.filterChipStyles}
        filterStyles={props.filterStyles}
        getContainerComponent={props.getContainerComponent}
        handleChipClick={props.handleChipClick}
        scrollDuration={props.scrollDuration}
        showLeftScroll={props.showLeftScroll}
        showRightScroll={props.showRightScroll}
      />
    </FilterChipContainerWrapper>
  );
};

FilterScrollContainer.propTypes = propTypes;
FilterScrollContainer.defaultProps = defaultProps;

export default FilterScrollContainer;
